import * as linkify from 'linkifyjs';
/**
 * Extract URLs from text content using linkifyjs for robust URL detection
 * This ensures consistent URL extraction logic across frontend and backend
 *
 * @param text - The text content to extract URLs from
 * @returns Array of normalized URLs (with https:// prefix if missing)
 */
export function extractUrls(text) {
    const links = linkify.find(text);
    const urls = links
        .filter(link => link.type === 'url')
        .map(link => {
        // Use the original value to check if protocol was in original text
        const originalValue = link.value;
        const href = link.href;
        // If the original value didn't have a protocol, prefer https://
        if (!originalValue.startsWith('http://') &&
            !originalValue.startsWith('https://')) {
            return `https://${originalValue}`;
        }
        // Otherwise use the href as-is (already has protocol)
        return href;
    });
    // Remove duplicates
    return [...new Set(urls)];
}
/**
 * Get all unique links from knowledge bases
 *
 * @param knowledgeBases - Array of knowledge bases with optional links
 * @returns Array of unique URLs from all knowledge base links
 */
export function getAllLinksFromKnowledgeBases(knowledgeBases) {
    const allLinks = new Set();
    knowledgeBases.forEach(kb => {
        if (kb.links) {
            kb.links.forEach(kbl => {
                allLinks.add(kbl.link.url);
            });
        }
    });
    return Array.from(allLinks);
}
/**
 * Test if a string contains any URLs
 */
export function containsUrls(text) {
    return extractUrls(text).length > 0;
}
/**
 * Get the domain/hostname from a URL
 */
export function getDomain(url) {
    try {
        const normalizedUrl = url.startsWith('http') ? url : `https://${url}`;
        return new URL(normalizedUrl).hostname;
    }
    catch {
        return url;
    }
}
//# sourceMappingURL=url-extraction.js.map